import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "./contexts/CartContext";

import Home from "./pages/Home";

// Interpretación
import Consecutiva from "./pages/servicios/interpretacion_consecutiva";
import Enlace from "./pages/servicios/interpretacion_de_enlace";
import Simultanea from "./pages/servicios/interpretacion_simultanea";

// Traducción
import Certificada from "./pages/servicios/traduccion_certificada";
import Especializada from "./pages/servicios/traduccion_especializada";
import NoCertificada from "./pages/servicios/traduccion_no_certificada";
import Urgente from "./pages/servicios/traduccion_urgente";
import OtrosServicios from "./pages/servicios/otros_servicios";

import ForceTrailingSlash from "./components/ForceTrailingSlash";

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <ForceTrailingSlash />

        <Routes>
          {/* Inicio */}
          <Route path="/" element={<Home />} />

          {/* Servicios de interpretación */}
          <Route
            path="/servicios/interpretacion-consecutiva/"
            element={<Consecutiva />}
          />

          <Route
            path="/servicios/interpretacion-de-enlace/"
            element={<Enlace />}
          />

          <Route
            path="/servicios/interpretacion-simultanea/"
            element={<Simultanea />}
          />

          {/* Servicios de traducción */}
          <Route
            path="/servicios/traduccion-certificada/"
            element={<Certificada />}
          />

          <Route
            path="/servicios/traduccion-especializada/"
            element={<Especializada />}
          />

          <Route
            path="/servicios/traduccion-simple/"
            element={<NoCertificada />}
          />

          <Route
            path="/servicios/traduccion-urgente/"
            element={<Urgente />}
          />

          <Route
            path="/servicios/otros-servicios/"
            element={<OtrosServicios />}
          />
        </Routes>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;